if (!customElements.get('big-cat-room')) customElements.define('big-cat-room', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    this.q = s => this.querySelector(s) || this.overlay?.querySelector(s);
    this.qa = s => [...this.querySelectorAll(s)];
    this.on = (el, type, fn, opts = {}) => el.addEventListener(type, fn, {...opts, signal:this.abort.signal});
    this.copy = JSON.parse(this.q('[data-copy]').textContent);
    this.dataset.cat = this.dataset.catModel;
    this.current = 'bed'; this.active = null; this.visible = false; this.starting = false;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.desktop = matchMedia('(min-width:990px)');
    this.items = this.qa('[data-room-item]').map(el => ({
      id:el.dataset.category, room:el.dataset.room, position:el.dataset.position.split(/\s+/).map(parseFloat),
      radius:Number(el.dataset.radius), title:el.querySelector('h3').textContent,
      description:el.querySelector('[data-description]').textContent, link:el.querySelector('[data-shop]'),
      related:el.querySelector('.related')
    }));
    this.shopBar = this.q('.mobile-shop');
    this.overlay = document.createElement('div'); this.overlay.className = 'big-interactive-room big-room-shop-overlay';
    this.overlay.append(this.shopBar); document.body.append(this.overlay);
    this.qa('[role=tab]').forEach(tab => {
      this.on(tab,'click',()=>this.setRoom(tab.dataset.room));
      this.on(tab,'keydown',e=>{
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault(); this.setRoom(e.key==='Home'?'bed':e.key==='End'?'bath':this.current==='bed'?'bath':'bed',true);
      });
    });
    const rail=this.q('.room-switcher');let swipeStart=null,swiped=false;
    this.on(rail,'pointerdown',e=>{swipeStart={x:e.clientX,y:e.clientY};swiped=false;});
    this.on(rail,'pointerup',e=>{if(!swipeStart)return;const dx=e.clientX-swipeStart.x,dy=e.clientY-swipeStart.y;swipeStart=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){swiped=true;this.setRoom(dx<0?'bath':'bed');}});
    this.on(rail,'pointercancel',()=>swipeStart=null);
    this.on(rail,'click',e=>{if(swiped){e.preventDefault();e.stopPropagation();swiped=false;}},{capture:true});
    this.on(this.q('[data-time]'),'change',e=>this.engine?.setTime(e.target.value));
    this.on(this.q('[data-pause]'),'click',()=>this.engine?.togglePause());
    this.on(this.q('[data-cat-target]'),'click',()=>{
      const heart=this.q('[data-cat-target]');clearTimeout(this.heartTimer);
      heart.classList.add('is-heart-flashing');
      this.heartTimer=setTimeout(()=>heart.classList.remove('is-heart-flashing'),550);
    });
    const escape = e => {if(e.key==='Escape'&&this.active){e.preventDefault();this.reset(true);}};
    this.on(this,'keydown',escape); this.on(this.overlay,'keydown',escape);
    this.on(this.reduced,'change',()=>this.engine?.setReduced(this.reduced.matches));
    this.on(this.desktop,'change',()=>{this.shopping();this.engine?.resize();});
    let down;
    this.on(document,'pointerdown',e=>{down={x:e.clientX,y:e.clientY};});
    this.on(document,'click',e=>{
      if(!this.active||!down||Math.hypot(e.clientX-down.x,e.clientY-down.y)>6||getSelection()?.toString())return;
      if(e.target.closest('button,a,input,select,textarea,summary,.selection,.mobile-shop,canvas'))return;
      this.reset();
    });
    this.on(document,'visibilitychange',()=>this.engine?.setVisible(this.visible&&!document.hidden));
    this.on(document,'shopify:block:select',e=>{
      const el=e.target.closest('[data-room-item]'),item=this.items.find(i=>i.id===el?.dataset.category);
      if(item){this.setRoom(item.room);this.select(item);}
    });
    this.observer = new IntersectionObserver(entries=>{
      this.visible=entries[0].isIntersecting;this.shopping();
      if(this.visible)this.start();
      this.engine?.setVisible(this.visible&&!document.hidden);
    });
    this.observer.observe(this.q('.room-explorer'));
    this.classList.add('is-enhanced');this.setRoom('bed');
  }
  async start() {
    if(this.starting)return;this.starting=true;const generation=this.abort;
    try {
      const {RoomEngine}=await import(this.dataset.runtime);
      if(generation.signal.aborted)return;
      this.engine=new RoomEngine(this);
      this.engine.setVisible(this.visible&&!document.hidden);
      await this.engine.switchRoom(this.current);
    } catch(error) {
      if(generation.signal.aborted)return;
      this.engine?.dispose();this.engine=null;this.status('unavailable');
      this.q('.stage').classList.remove('is-ready');
      this.q('[data-pause]').disabled=true;
      console.warn('BIG room: interactive renderer unavailable',error);
    }
  }
  disconnectedCallback() {
    clearTimeout(this.heartTimer);this.q('[data-cat-target]')?.classList.remove('is-heart-flashing');
    this.abort?.abort();this.abort=null;this.observer?.disconnect();this.engine?.dispose();this.engine=null;
    this.q('[data-dots]').replaceChildren();this.q('[data-cat-target]').hidden=true;
    this.q('[data-fixture]').hidden=true;this.q('.stage').classList.remove('is-ready');
    this.shopBar.hidden=true;this.append(this.shopBar);this.overlay.remove();
    this.classList.remove('is-enhanced');
  }
  status(key){this.q('[data-status]').textContent=this.copy[key]||'';}
  catStatus(key){this.q('[data-cat-status]').textContent=this.copy[key]||'';}
  shopping(){
    this.shopBar.hidden=!(this.active&&this.visible&&!this.desktop.matches);
    this.q('.room-explorer').classList.toggle('has-selection',!!this.active);
  }
  card(item){
    if(!item)return;
    this.q('[data-title]').textContent=item.title;this.q('[data-description-display]').textContent=item.description;
    const a=this.q('[data-cta]');a.textContent=this.copy.shop_collection+' ↗';a.href=item.link.href;
    a.setAttribute('aria-label',item.link.textContent);
    this.q('[data-related]').replaceChildren(...[...item.related.children].map(n=>n.cloneNode(true)));
    this.q('[data-mobile-title]').textContent=item.title;
    const m=this.q('[data-mobile-link]');m.href=item.link.href;m.setAttribute('aria-label',item.link.textContent);
  }
  select(item){
    if(this.active===item){this.reset();return;}
    this.active=item;this.card(item);this.shopping();
    this.qa('[data-select]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.select===item.id)));
    this.engine?.focus(item);this.status('detail');
    if(!this.desktop.matches)this.q('.stage').scrollIntoView({block:'center',behavior:this.reduced.matches?'instant':'smooth'});
  }
  reset(focus=false){
    const previous=this.active;this.active=null;this.shopping();
    this.qa('[data-select]').forEach(b=>b.setAttribute('aria-pressed','false'));
    this.engine?.overview();this.status(this.q('.stage').classList.contains('is-ready')?'overview':'unavailable');
    if(focus&&previous)this.q('.category-pill[data-select="'+previous.id+'"]')?.focus({preventScroll:true});
  }
  setRoom(room,focus=false){
    if(!['bed','bath'].includes(room))return;
    this.current=room;this.active=null;this.shopping();
    this.qa('[role=tab]').forEach(t=>{const yes=t.dataset.room===room;t.setAttribute('aria-selected',String(yes));t.tabIndex=yes?0:-1;if(yes&&focus)t.focus({preventScroll:true});});
    const stage=this.q('.stage');stage.dataset.room=room;stage.setAttribute('aria-labelledby','room-tab-'+room+'-'+this.dataset.section);
    const poster=stage.querySelector('img');poster.src=this.dataset[room+'Poster'];poster.removeAttribute('srcset');poster.alt=this.copy[room+'_image'];
    this.q('[data-room-label]').textContent=this.copy[room];this.q('[data-kicker]').textContent=this.copy[room];
    const items=this.items.filter(i=>i.room===room),list=this.q('[data-categories]');
    list.replaceChildren();this.q('[data-dots]').replaceChildren();
    for(const item of items){
      const b=document.createElement('button');b.type='button';b.className='category-pill';b.textContent=item.title;
      b.dataset.select=item.id;b.setAttribute('aria-pressed','false');this.on(b,'click',()=>this.select(item));list.append(b);
      const dot=document.createElement('button');dot.type='button';dot.className='room-product-dot';
      dot.dataset.select=item.id;dot.setAttribute('aria-label',this.copy.explore+' '+item.title);dot.setAttribute('aria-pressed','false');
      dot.title=item.title;dot.hidden=true;this.on(dot,'click',()=>this.select(item));this.q('[data-dots]').append(dot);
    }
    this.card(items[0]);this.status('loading');
    this.engine?.switchRoom(room);
  }
});
